/**
 * @typedef {Object} LeadsBenchmarkData
 * @property {number} chatLeads
 * @property {number} chatFinancialInterestLeads
 * @property {number} emailLeads
 * @property {number} emailFinancialInterestLeads
 * @property {number} phoneLeads
 * @property {number} phoneFinancialInterestLeads
 * @property {number} totalLeadsFinancialInterest
 * @property {number} totalLeads
 */

/**
 * @typedef {Object} LeadsBenchmarkResponse
 * @property {LeadsBenchmarkData} current
 * @property {LeadsBenchmarkData} previous
 */

/**
 * @constant leadsBenchmarkDataInitialState
 * @type {LeadsBenchmarkResponse}
 */
export const leadsBenchmarkDataInitialState = {
  current: {
    chatLeads: 0,
    chatFinancialInterestLeads: 0,
    emailLeads: 0,
    emailFinancialInterestLeads: 0,
    phoneLeads: 0,
    phoneFinancialInterestLeads: 0,
    totalLeadsFinancialInterest: 0,
    totalLeads: 0,
  },
  previous: {
    chatLeads: 0,
    chatFinancialInterestLeads: 0,
    emailLeads: 0,
    emailFinancialInterestLeads: 0,
    phoneLeads: 0,
    phoneFinancialInterestLeads: 0,
    totalLeadsFinancialInterest: 0,
    totalLeads: 0,
  },
};

/**
 * @typedef {Object} LeadsBenchmarkYearyOverviewData
 * @property {number} totalLeads
 * @property {number} totalFinancialInterestLeads
 */

/**
 * @typedef {Object} LeadsBenchmarkYearyOverviewDataByMonth
 * @property {LeadsBenchmarkYearyOverviewData} jan
 * @property {LeadsBenchmarkYearyOverviewData} feb
 * @property {LeadsBenchmarkYearyOverviewData} mar
 * @property {LeadsBenchmarkYearyOverviewData} apr
 * @property {LeadsBenchmarkYearyOverviewData} may
 * @property {LeadsBenchmarkYearyOverviewData} jun
 * @property {LeadsBenchmarkYearyOverviewData} jul
 * @property {LeadsBenchmarkYearyOverviewData} aug
 * @property {LeadsBenchmarkYearyOverviewData} sep
 * @property {LeadsBenchmarkYearyOverviewData} oct
 * @property {LeadsBenchmarkYearyOverviewData} nov
 * @property {LeadsBenchmarkYearyOverviewData} dec
 */

/**
 * @typedef {Object} LeadsBenchmarkYearyOverviewDataResponse
 * @property {LeadsBenchmarkYearyOverviewDataByMonth} current
 * @property {LeadsBenchmarkYearyOverviewDataByMonth} previous
 */

/**
 * @constant leadsBenchmarkYearlyOverviewInitialState
 * @type {LeadsBenchmarkYearyOverviewDataResponse}
 */
export const leadsBenchmarkYearlyOverviewInitialState = {
  current: {
    jan: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    feb: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    mar: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    apr: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    may: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    jun: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    jul: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    aug: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    sep: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    oct: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    nov: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    dec: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
  },
  previous: {
    jan: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    feb: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    mar: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    apr: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    may: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    jun: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    jul: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    aug: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    sep: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    oct: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    nov: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
    dec: {
      totalLeads: 0,
      totalFinancialLeads: 0,
    },
  },
};
